import { useExportAnalyticsReportCSV } from '../../../hooks/useExportAnalyticsReportCSV';
import { useAnalyticsContext } from '../../../providers/AnalyticsProvider';
import { getExternalSource } from '../../../utils/getExternalSource';
export const useAnalyticsReportsData = () => {
    const { reportsDefinitions, isLoading } = useAnalyticsContext();
    const { exportReportCSV } = useExportAnalyticsReportCSV();
    const data = reportsDefinitions.map((reportDefinition) => ({
        id: reportDefinition.id,
        name: reportDefinition.name,
        externalSource: getExternalSource(reportDefinition.dataSource),
    }));
    return {
        data,
        isLoading,
        onExport: exportReportCSV,
    };
};
